import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { map } from 'lodash';
import { IButtonProps, ButtonVariant } from '@amobee/component-library';


export interface FilterOption {
  label: string;
  name: number | string; // unique value
  // component defined properties
  [prop: string]: any;
}

export interface FilterSetup {
  label: string;
  name: string; // unique value
  options: FilterOption[] | string;
  initialValue: number | string;
  // component defined properties
  [prop: string]: any;
}

@Component({
  selector: 'list-filter',
  templateUrl: './list-filter.component.html',
  styleUrls: ['./list-filter.component.scss']
})
export class ListFilterComponent implements OnInit {

  public _filterSetup: FilterSetup[];

  @Input() public set filterSetup(value: FilterSetup[]) {
    this._filterSetup = map(value, (filter: FilterSetup) => {
      return Object.assign({}, filter, {
        onClick: ($event: any) => {
          this.onOptionSelect($event.props);
        }
      });
    });
  }
  public get filterSetup(): FilterSetup[] {
    return this._filterSetup;
  }

  @Input() public hide?: boolean = false;
  @Output() public filterSelected = new EventEmitter<FilterSetup>();

  public buttonProps: IButtonProps = {
    icon: 'Filter',
    variant: ButtonVariant.STATIC_BORDERLESS
  };

  constructor() { }

  ngOnInit() { }

  public onOptionSelect(item: FilterSetup): void {
    this.filterSelected.emit(item);
  }

}
